"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateCartCouponRequest = instanceOfUpdateCartCouponRequest;
exports.UpdateCartCouponRequestFromJSON = UpdateCartCouponRequestFromJSON;
exports.UpdateCartCouponRequestFromJSONTyped = UpdateCartCouponRequestFromJSONTyped;
exports.UpdateCartCouponRequestToJSON = UpdateCartCouponRequestToJSON;
exports.UpdateCartCouponRequestToJSONTyped = UpdateCartCouponRequestToJSONTyped;
/**
 * Check if a given object implements the UpdateCartCouponRequest interface.
 */
function instanceOfUpdateCartCouponRequest(value) {
    return true;
}
function UpdateCartCouponRequestFromJSON(json) {
    return UpdateCartCouponRequestFromJSONTyped(json, false);
}
function UpdateCartCouponRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'cartItemNo': json['cartItemNo'] == null ? undefined : json['cartItemNo'],
        'promotionsDiscountNo': json['promotionsDiscountNo'] == null ? undefined : json['promotionsDiscountNo'],
    };
}
function UpdateCartCouponRequestToJSON(json) {
    return UpdateCartCouponRequestToJSONTyped(json, false);
}
function UpdateCartCouponRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'cartItemNo': value['cartItemNo'],
        'promotionsDiscountNo': value['promotionsDiscountNo'],
    };
}
